import React from "react";
import {DateTimeFilterPopover} from "./DateTimeFilterPopover.jsx";
import {isDateTimeFilterEnabled} from "./consts.jsx";

export const DateTimeFilterPopoverFactory = ({panel}) => {
    if (!isDateTimeFilterEnabled(panel)) {
        return null;
    }

    return <DateTimeFilterPopover />;
};
